export default "__VITE_ASSET__BtvfRuLg__"